<script>
  import files from '@/shared/files/files'
import { defineComponent } from 'vue'

  const name = 'BarraPesquisa'

  export default defineComponent({
    name,

    components: {},

    emits: ['change', 'pesquisa'],

    props: {
      placeholder: {
        type: String,
        required: true,
      },
      sempreAberto: {
        type: Boolean,
        default: false,
      },
      modelValue: {
        default: ''
      }
    },

    mounted() {},

    updated() {},

    data() {
      return {
        iconePesquisa: files.retornaUrlImagem('search.svg'),
        expandido: false,
        modelValueInterno: '',
        timer: null,
      }
    },

    methods: {},

    computed: {},

    watch: {
      modelValueInterno(){
        this.$emit('update:modelValue', this.modelValueInterno);
        window.clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.$emit('pesquisa', this.modelValueInterno)
        }, 1000);
      }
    }
  })
</script>

<template>
  <div
    class="container-barra-pesquisa"
    :class="{
      expandido: expandido || sempreAberto || modelValueInterno
    }"
  >

    <div class="icone-pesquisa">
      <img class="icone-lupa" src="@/assets/imgs/search.svg">
    </div>

    <div class="divisor"></div>

    <div class="area-input-pesquisa">
      <input
        v-model="modelValueInterno"
        class="input-pesquisa"
        :placeholder="placeholder"
        @focus="expandido = true"
        @blur="expandido = false"
        @input="$emit('change')"
        type="text" >
    </div>
  </div>
</template>

<style scoped>

.container-barra-pesquisa {
  background-color: white;
  display: grid;
  grid-template-columns: 27px 2px auto;
  grid-template-rows: auto;
  align-content: center;
  border: 1px solid #ececec;
  transition: .5s;
  overflow: hidden;
  border-radius: 8px;
  grid-column-gap: 5px;
}

.icone-pesquisa {
  display: flex;
  align-items: center;
  justify-content: center;
}

.divisor{
  background-color: #b4b4b4;
  width: 1px;
}

.input-pesquisa{
  outline: none;
  /* color: #9c9c9c; */
  color: black;
  width: 100%;
  padding-left: 10px;
}

.input-pesquisa:active{
  width: 300px;
}

.icone-lupa{
  min-width: 20px;
}


@media (min-width:1240px) {
.container-barra-pesquisa {
  height: 32px;
  width: 32px;
  grid-template-columns: 27px 2px auto;
}

.expandido, .container-barra-pesquisa:hover{
  width: 280px;
}

.icone-lupa {
  height: 18px;
}
}

@media (min-width:1500px) {
.container-barra-pesquisa {
  height: 40px;
  width: 40px;
  grid-template-columns: 35px 2px auto;
}

.expandido, .container-barra-pesquisa:hover{
  width: 350px;
}

.icone-lupa {
  height: 21px;
}
}
</style>
